<template>
    <div class="card bg-light rounded-1 shadow-lg p-3 mb-5">
        <div class="card-body p-0">
            <div>
                <div>
                    <section class="py-1">
                        <div class="w-full xl:full mb-12 xl:mb-0 px-0 mx-auto mt-24">
                            <div v-if="traps && traps.length > 0"
                                class="relative bg-light flex flex-col min-w-0 break-words  w-full mb-6 shadow-lg rounded ">
                                <TrapsiteMap @more_info="switchToMore" @filters="applyFilter" :traps="traps" />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>

    <!-- Button trigger modal -->
    <button type="button" class="btn btn-warning rounded-pill text-light fab" data-bs-toggle="modal"
        data-bs-target="#exampleModal">
        <i class="bi bi-clipboard-plus-fill fs-3"></i>
    </button>

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <form class="row g-3 p-4 shadow bg-light text-start">
                        <label for="">New Port</label>
                        <div class="col-md-5">
                            <label class="form-label">Trap Site</label>
                            <select class="form-select form-select-sm" v-model="trap.trapSiteId" required>
                                <option value="" disabled selected>Select Trap Site</option>
                                <option v-for="trap in authTraps" :key="trap.id" :value="trap.id">
                                    {{ trap.name || trap.site_name || trap.id }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-5">
                            <label class="form-label">Pest Type</label>
                            <select class="form-select form-select-sm" v-model="trap.riskCategoryId" required>
                                <option value="" disabled selected>Select Trap Type</option>
                                <option v-for="category in categories" :key="category.id" :value="category.id">
                                    {{ category.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="inputPassword4" class="form-label">Count</label>
                            <input type="text" v-model="trap.pestCount" class="form-control form-control-sm bg-light"
                                id="inputPassword4">
                        </div>
                        <div class="col-md-12">
                            <label for="inputPassword4" class="form-label">Report</label>
                            <textarea type="text" v-model="trap.report" class="form-control form-control-sm bg-light"
                                id="inputPassword4"></textarea>
                        </div>
                        <div class="col-md-2 pt-4">
                            <button class="btn btn-sm btn-success rounded-3 px-4" v-if="!isLoader"
                                @click="createReport">Submit Report</button>
                            <div class="barLoader " v-if="isLoader"></div>
                            <p v-if="isMsg" class="text-warning">{{ msg }}</p>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>


    <a class="btn btn-primary" ref="timelineOffCanvas" hidden data-bs-toggle="offcanvas" href="#offcanvasExample"
        role="button" aria-controls="offcanvasExample">
        Link with href
    </a>

    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">Report Timeline</h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">

            <div class="container mt-5 mb-5" v-if="selectedTrap">
                <div class="row">
                    <div class="col-md-12 text-start">
                        <ul class="timeline">
                            <li v-for="(report, index) in selectedTrap.trap_reports" :key="selectedTrap.id">
                                <a target="_blank" href="#">{{ report.riskCategory.name }}</a>
                                <p class="my-0">{{ report.report }}</p>
                                <p class="my-0 fw-bold">Trap Count:{{ report.pestCount }}</p>
                                <a href="#" style="font-size: 11px; color: #414141 ;"
                                    class="text-end float-end">{{ report.updatedAt }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import TrapsiteMap from './trapsiteMap.vue'
import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";

import "leaflet/dist/leaflet.css";
import {
    LMap,
    LTileLayer,
    LMarker,
} from "@vue-leaflet/vue-leaflet";
import jwtDecode from 'jwt-decode';
import { applyFilter } from '@turf/turf';


export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        TrapsiteMap,
        ColorPicker
    },
    data() {
        return {
            isMsg: '',
            msg: '',
            traps: [],
            authTraps: [],
            categories: [],
            selectedTrap: null,
            trap: {
                pestCount: 0,
                report: '',
                feedback: '',
                trapSiteId: null,
                riskCategoryId: null
            },


            autoLocation: true,
            isLoader: false,
            zoom: 15,
            center: [7.998338, -1.213402],
            viewMoreInfo: false,
            switchToMap: true,
            viewRisks: 'listRisks',
            isUpdateRisk: false,
            activeTab: 'risk',
            searchVal: '',
            selectedOfficers: [],
            allRiskResponders: [],
            selectedZone: {},
            locationDataRes: [],
            searchLocation: '',
            zones: [],
            categories: [],
            category: '',
            officers: [],
            risk: {
                riskCategoryId: '',
                // name: '',
                description: '',
                riskZoneId: '',
                location: '',
                isActive: false,
                riskCategory: {},
                riskZone: {},
                riskResponders: [],
                district_id: null,
                count: 0
            },
            riskView: {},

        }
    },
    created() {
        this.getAllTraps()
        this.getAuthTraps()
        this.getCategories()
        this.jwt = jwtDecode(this.getCookie('token'));
    },
    computed: {
        areAllSelected() {
            if (!this.risk.riskResponders) {
                this.risk.riskResponders = []
            }
            return this.officers.length > 0 && this.officers.every(officer => this.risk.riskResponders.includes(officer.id));
        }
    },
    methods: {
        getAllTraps() {
            axios
                .get("https://aghub.miphost.com/api/broadcast/trap_sites")
                .then((response) => {
                    this.traps = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getAuthTraps() {
            var token = this.getCookie('token')
            axios
                .get("https://aghub.miphost.com/api/broadcast/auth_trapsites",
                    { headers: { 'Authorization': `Bearer ${token}` } }
                )
                .then((response) => {
                    this.authTraps = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        createReport(e) {
            this.isLoader = true
            e.preventDefault();
            var token = this.getCookie('token')
            axios.post('https://aghub.miphost.com/api/broadcast/trap-report', this.trap,
                { headers: { 'Authorization': `Bearer ${token}` } })
                .then(response => {
                    this.isLoader = false
                    this.trap = {
                        pestCount: 0,
                        report: '',
                        feedback: '',
                        trapSiteId: null,
                        riskCategoryId: null
                    }
                }).catch(error => {
                    console.log(error);
                    setTimeout(() => {
                        this.isMsg = true
                        this.msg = error.response.data.message
                    }, 3000);
                })
        },
        getZones() {
            axios.get('https://aghub.miphost.com/api/broadcast/zone')
                .then(response => {
                    this.zones = response.data
                }).catch(error => {
                    console.log(error);
                })
        },
        getZonesById(id) {
            axios.get('https://aghub.miphost.com/api/broadcast/zone/' + id)
                .then(response => {
                    this.zone = response.data
                }).catch(error => {
                    console.log(error);
                })
        },
        async getCategories() {
            await axios.get('https://aghub.miphost.com/api/broadcast/risk_categories')
                .then(response => {
                    this.categories = response.data
                    console.log(this.categories)
                }).catch(error => {
                    console.log(error);
                })
        },
        handleFileUpload(event) {
            this.images = event.target.files;
        },
        search(location = null) {
            var url = `https://aghub.miphost.com/api/weather/locations/${location}`
            if (!location) {
                url = `https://aghub.miphost.com/api/weather/locations`
            }
            axios.get(url)
                .then(response => {
                    this.locationDataRes = response.data
                }).catch(error => {
                    console.log(error);
                })
        },
        updateRiskClicked(data) {
            this.viewMoreInfo = false
            this.viewRisks = 'addRisks'
            this.risk = data
            this.isUpdateRisk = true
        },
        getOfficers() {
            var token = this.getCookie('token')
            axios.get('https://aghub.miphost.com/api/broadcast/',
                { headers: { 'Authorization': `Bearer ${token}` } })
                .then(response => {
                    this.officers = response.data
                }).catch(error => {
                    console.log(error);
                })
        },
        searchOfficers() {
            var token = this.getCookie('token')
            axios.get('https://aghub.miphost.com/api/broadcast/search?searchVal=' + this.searchVal,
                { headers: { 'Authorization': `Bearer ${token}` } })
                .then(response => {
                    this.officers = response.data
                }).catch(error => {
                    console.log(error);
                })
        },
        async createRisk() {
            this.isLoader = true
            var token = this.getCookie('token')
            try {
                const formData = new FormData();
                formData.append('riskCategoryId', this.risk.riskCategoryId);
                formData.append('district_id', this.risk.district_id);
                formData.append('count', this.risk.count);
                // formData.append('name', this.risk.name);
                formData.append('description', this.risk.description);
                formData.append('location', JSON.stringify(this.risk.location));
                formData.append('isActive', this.risk.isActive);
                formData.append('riskZoneId', this.risk.riskZoneId);

                for (let i = 0; i < this.images.length; i++) {
                    formData.append('images', this.images[i]);
                }

                const response = await axios.post('https://aghub.miphost.com/api/broadcast/risk', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`
                    }
                });
                this.isLoader = false
                this.viewRisks = true
                this.risk = {
                    riskCategoryId: '',
                    // name: '',
                    description: '',
                    riskZoneId: '',
                    location: '',
                    isActive: false,
                    riskCategory: {},
                    riskZone: {},
                    riskResponders: [],
                }
                this.activeTab = 'risk'
            } catch (error) {
                console.error('There was an error creating the risk:', error);
                setTimeout(() => {
                    this.isMsg = true
                    msg = error.response.data.message
                }, 3000);
                this.isMsg = false
                this.isLoader = false
            }
        },
        async updateRisk(id) {
            this.isLoader = true
            var token = this.getCookie('token')
            delete this.risk.createdAt
            delete this.risk.updatedAt
            delete this.risk.extensionsOfficerId
            delete this.risk.riskZone
            delete this.risk.riskImages
            delete this.risk.extensionsOfficer
            delete this.risk.riskCategory


            axios.post('https://aghub.miphost.com/api/broadcast/risk/update/' + id, this.risk,
                { headers: { 'Authorization': `Bearer ${token}` } })
                .then(response => {
                    this.isLoader = false
                }).catch(error => {
                    console.log(error);
                    setTimeout(() => {
                        this.isMsg = true
                        msg = error.response.data.message
                    }, 3000);
                    this.isMsg = false
                    this.isLoader = false
                })
        },
        getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        async getLocation(location) {
            if (this.autoLocation) {
                navigator.geolocation.getCurrentPosition(async (position) => {
                    let lat = position.coords.latitude;
                    let long = position.coords.longitude;
                    this.risk.location = { coordinates: `${lat.toFixed(4)}, ${long.toFixed(4)}`, name: await this.reverseGeocode(lat, long) }
                });
            } else {
                this.risk.location = { coordinates: `${location.latitude}, ${location.longitude}`, name: location.location }
                this.locationDataRes = []
            }
        },
        async reverseGeocode(lat, lon) {
            const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`;
            try {
                const response = await fetch(url);
                const data = await response.json();
                if (data.address) {
                    return `${data.address.suburb} - ${data.address.town},<br> ${data.address.county},<br> ${data.address.country}`;
                } else {
                    return 'Location not found';
                }
            } catch (error) {
                console.error('Error fetching location:', error);
                return 'Error fetching location';
            }
        },
        addCategory() {
            this.isLoader = true
            var token = this.getCookie('token')
            axios.post('https://aghub.miphost.com/api/broadcast/risk-category', { name: this.category },
                { headers: { 'Authorization': `Bearer ${token}` } })
                .then(response => {
                    this.getZones()
                    this.isLoader = false
                }).catch(error => {
                    console.log(error);
                    setTimeout(() => {
                        this.isMsg = true
                        msg = error.response.data.message
                    }, 3000);
                    this.isMsg = false
                    this.isLoader = false
                })
        },
        toggleCatDropdown() {
            this.$refs.categoryToggle.click()
        },
        applyFilter(filter) {
            axios.get("https://aghub.miphost.com/api/broadcast/trap_sites",{
                params:filter
            })
            .then((response) => {
                this.traps = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        },
        submitSelectedOfficers() {
            this.isLoader = true
            var token = this.getCookie('token')
            if (this.selectedOfficers.length === 0) {
                alert('No officers selected');
                return;
            }

            const promises = this.selectedOfficers.map(officerId =>
                axios.post('https://aghub.miphost.com/api/broadcast/assignOfficerToZone',
                    { extensionsOfficerId: officerId, riskZoneId: this.selectedZone.id },
                    { headers: { 'Authorization': `Bearer ${token}` } }
                )
            );

            Promise.all(promises)
                .then(responses => {
                    alert('All officers submitted successfully');
                    this.getZones()
                    this.isLoader = false
                })
                .catch(error => {
                    alert('Error submitting officers');
                    setTimeout(() => {
                        this.isMsg = true
                        msg = error.response.data.message
                    }, 3000);
                    this.isMsg = false
                    this.isLoader = false
                });
        },
        switchToMore(trap) {

            this.selectedTrap = trap
            if (this.selectedTrap) {
                this.$refs.timelineOffCanvas.click()
                console.log('selected trap:', this.selectedTrap)
            }
        },
        generateRandomNumber(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        toggleAllOfficers(event) {
            if (event.target.checked) {
                const allOfficerIds = this.officers.map(officer => officer.id);
                this.risk.riskResponders = [...new Set([...this.risk.riskResponders, ...allOfficerIds])];
            } else {
                this.risk.riskResponders = this.risk.riskResponders.filter(id => !this.officers.some(officer => officer.id === id));
            }
        },

        async fetchRegions() {
            try {
                const response = await axios.get('https://aghub.miphost.com/api/cc/regions');
                this.regions = response.data
            } catch (error) {
                console.log(error);
            }
        },
        async getDistricts() {
            try {
                const response = await axios.get(`https://aghub.miphost.com/api/cc/districts/${this.region_id}`);
                this.districts = response.data
                console.log(this.districts)
            } catch (error) {
                console.log('Error fetching districts:', error);
            }
        },

        zoomImage(e, index) {
            const img = this.$refs.galleryImages[index];
            const rect = img.getBoundingClientRect();
            const x = e.clientX - rect.left - rect.width / 2;
            const y = e.clientY - rect.top - rect.height / 2;

            img.style.transform = `scale(2) translate(${x / 10}px, ${y / 10}px)`;
        },
        resetImage(index) {
            const img = this.$refs.galleryImages[index];
            img.style.transform = "scale(1) translate(0, 0)";
            img.style.transition = "transform 0.5s ease-out";
            setTimeout(() => {
                img.style.transition = ""; // reset transition for next hover
            }, 500);
        },



    },
}
</script>



<style scoped>
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 10px;
    font-family: 'Ubuntu', sans-serif;
}

.gallery-item {
    cursor: pointer;
}

.gallery-overflow {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 220px;
    /* fixed uniform height */
}

.gallery-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease-out;
    will-change: transform;
    display: block;
}




.risk-header {
    background: #2b5207;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem 0.5rem 0 0;
}

.back-btn {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.3);
    padding: 0.35rem 0.75rem;
    border-radius: 0.4rem;
    transition: background 0.3s;
}

.back-btn:hover {
    background: rgba(0, 0, 0, 0.5);
}
</style>


<style scoped>
.masonry {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-auto-rows: 10px;
    gap: 20px;
}

.item {
    background-color: #ffffff00;
    padding: 0px;
    box-sizing: border-box;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
    color: #fff;
    border-radius: 8px;

}

.item:hover {
    transform: translateY(-10px);
}

.riskImages {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 8px;
}

.nav-tabs {
    border-bottom: 1px solid #26490600;
}

.form-control,
.form-select {
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
    background-color: transparent;
}

.active {
    background-color: #b90101 !important;
    color: #fff !important;
    border: 1px solid rgb(185, 1, 1) !important;
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}

.nav-custom {
    text-decoration: none;
    border: 1px solid rgb(175, 175, 175);
    padding: 0.2rem 1rem;
    color: #3c3c3c;
    border-radius: 3px;
    margin-inline: 6px;
}

.nav-custom:hover {
    color: #444444;
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}

.action_badge:hover {
    background-color: #86d1fc;
    border-radius: 50%;

}

.input-group-text {
    background-color: #e9ecef00 !important;
    border: none !important;
    padding: 0px !important;
}

.input-group-text:hover {
    color: #037205 !important;
    cursor: pointer;
}

.btn-close {
    width: 3px !important;
    height: 3px !important;
    margin-top: 6px;
}

.alert a {
    margin-top: 3px !important;
    opacity: .6;

}

.alert a:hover {
    opacity: 1;
}

.alert {
    padding: 2px 14px !important;
    border-radius: 50rem !important;
}

/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
    transition: opacity 2.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

.dropdown-toggle::after {
    display: none !important;
}

.card {
    margin-top: 4%;
    /* min-height: 90% !important; */
    min-width: 80% !important;
    /* overflow-x: scroll; */
    border-radius: 1rem;
    transition: 0.5s;
    background-color: #f0f0f0 !important;
}

.stockList:hover>* {
    --bs-table-accent-bg: rgb(0 0 0 / 0%) !important;
}

.table-sm>:not(caption)>*>* {
    padding: 0.6rem .25rem !important;
}

/* **************************** */

.form-control-sm,
.form-select-sm {
    background-color: #1a222600;
    border: none;
    border-bottom: 2px solid #dc3545;
    border-top: 0px;
    border-radius: 0px;
    font-weight: 500;
    outline: 0;
    margin-bottom: 20px;
    padding-left: 10px;
}

.form-control-sm,
.form-select-sm {
    font-size: 0.75rem !important;
}

.form-control:focus .form-select-sm.focus {
    border-color: inherit;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-bottom: 2px solid #dc3545 !important;
    outline: 0;
    background-color: #31383b00;
}

input:focus {
    outline: none;
    box-shadow: 0 0 0;
}

label {
    margin-bottom: 0px;
}

.form-label {
    font-size: 10px;
    color: #464646;
    font-weight: 500;
    letter-spacing: 1px;
}

.spinner-border {
    display: block !important;
    ;
    width: 1rem;
    height: 1rem;
    color: #dc3545;
    border: .2em solid currentColor;
    border-right-color: transparent !important;
}

.spinner-grow-sm {
    width: .45rem;
    height: .45rem;
    vertical-align: 0.576em !important;
    color: #f68888;
}
</style>


<style scoped>
.fab {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1050;
    /* stays above other elements */
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* Blog 
---------------------*/
.blog-grid {
    box-shadow: 0 0 30px rgba(31, 45, 61, 0.125);
    border-radius: 5px;
    overflow: hidden;
    background: #ffffff;
    margin-top: 15px;
    margin-bottom: 15px;
}

.blog-grid .blog-img {
    position: relative;
}

.blog-grid .blog-img .date {
    position: absolute;
    background: #fc5356;
    color: #ffffff;
    padding: 8px 15px;
    left: 10px;
    top: 10px;
    border-radius: 4px;
}

.blog-grid .blog-img .date span {
    font-size: 22px;
    display: block;
    line-height: 22px;
    font-weight: 700;
}

.blog-grid .blog-img .date label {
    font-size: 14px;
    margin: 0;
}

.blog-grid .blog-info {
    padding: 20px;
}

.blog-grid .blog-info h5 {
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 10px;
}

.blog-grid .blog-info h5 a {
    color: #20247b;
}

.blog-grid .blog-info p {
    margin: 0;
}

.blog-grid .blog-info .btn-bar {
    margin-top: 20px;
}


/* Blog Sidebar
-------------------*/
.blog-aside .widget {
    box-shadow: 0 0 30px rgba(31, 45, 61, 0.125);
    border-radius: 5px;
    overflow: hidden;
    background: #ffffff;
    margin-top: 15px;
    margin-bottom: 15px;
    width: 100%;
    display: inline-block;
    vertical-align: top;
}

.blog-aside .widget-body {
    padding: 15px;
}

.blog-aside .widget-title {
    padding: 15px;
    border-bottom: 1px solid #eee;
}

.blog-aside .widget-title h3 {
    font-size: 20px;
    font-weight: 700;
    color: #fc5356;
    margin: 0;
}

.blog-aside .widget-author .media {
    margin-bottom: 15px;
}

.blog-aside .widget-author p {
    font-size: 16px;
    margin: 0;
}

.blog-aside .widget-author .avatar {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid;
}

.blog-aside .widget-author h6 {
    font-weight: 600;
    color: #20247b;
    font-size: 22px;
    margin: 0;
    padding-left: 20px;
}

.blog-aside .post-aside {
    margin-bottom: 15px;
}

.blog-aside .post-aside .post-aside-title h5 {
    margin: 0;
}

.blog-aside .post-aside .post-aside-title a {
    font-size: 18px;
    color: #20247b;
    font-weight: 600;
}

.blog-aside .post-aside .post-aside-meta {
    padding-bottom: 10px;
}

.blog-aside .post-aside .post-aside-meta a {
    color: #6F8BA4;
    font-size: 12px;
    text-transform: uppercase;
    display: inline-block;
    margin-right: 10px;
}

.blog-aside .latest-post-aside+.latest-post-aside {
    border-top: 1px solid #eee;
    padding-top: 15px;
    margin-top: 15px;
}

.blog-aside .latest-post-aside .lpa-right {
    width: 90px;
}

.blog-aside .latest-post-aside .lpa-right img {
    border-radius: 3px;
}

.blog-aside .latest-post-aside .lpa-left {
    padding-right: 15px;
}

.blog-aside .latest-post-aside .lpa-title h5 {
    margin: 0;
    font-size: 15px;
}

.blog-aside .latest-post-aside .lpa-title a {
    color: #20247b;
    font-weight: 600;
}

.blog-aside .latest-post-aside .lpa-meta a {
    color: #6F8BA4;
    font-size: 12px;
    text-transform: uppercase;
    display: inline-block;
    margin-right: 10px;
}

.tag-cloud a {
    padding: 4px 15px;
    font-size: 13px;
    color: #ffffff;
    background: #20247b;
    border-radius: 3px;
    margin-right: 4px;
    margin-bottom: 4px;
    text-decoration: none;
}

.tag-cloud a:hover {
    background: #fc5356;
}

.article {
    box-shadow: 0 0 30px rgba(31, 45, 61, 0.125);
    border-radius: 5px;
    overflow: hidden;
    background: #ffffff;
    padding: 0px;
    padding-top: 0px !important;
    margin: 0px 0 30px;
}

.article .article-title {
    padding: 15px 0 20px;
}

.article .article-title h6 {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 20px;
}

.article .article-title h6 a {
    text-transform: uppercase;
    color: #fc5356;
    border-bottom: 1px solid #fc5356;
}

.article .article-title h2 {
    color: #20247b;
    font-weight: 600;
}

.article .article-title .media {
    padding-top: 15px;
    border-bottom: 1px dashed #ddd;
    padding-bottom: 20px;
}

.article .article-title .media .avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    overflow: hidden;
    border: 5px solid;

}

.article .article-title .media .media-body {
    padding-left: 8px;
}

.article .article-title .media .media-body label {
    font-weight: 600;
    color: #fc5356;
    margin: 0;
}

.article .article-title .media .media-body span {
    display: block;
    font-size: 12px;
}

.article .article-content h1,
.article .article-content h2,
.article .article-content h3,
.article .article-content h4,
.article .article-content h5,
.article .article-content h6 {
    color: #20247b;
    font-weight: 600;
    margin-bottom: 15px;
}

.article .article-content blockquote {
    max-width: 600px;
    padding: 15px 0 30px 0;
    margin: 0;
}

.article .article-content blockquote p {
    font-size: 20px;
    font-weight: 500;
    color: #fc5356;
    margin: 0;
}

.article .article-content blockquote .blockquote-footer {
    color: #20247b;
    font-size: 16px;
}

.article .article-content blockquote .blockquote-footer cite {
    font-weight: 600;
}

.article .tag-cloud {
    padding-top: 10px;
}

.article-comment {
    box-shadow: 0 0 30px rgba(31, 45, 61, 0.125);
    border-radius: 5px;
    overflow: hidden;
    background: #ffffff;
    padding: 20px;
}

.article-comment h4 {
    color: #20247b;
    font-weight: 700;
    margin-bottom: 25px;
    font-size: 22px;
}

img {
    max-width: 100%;
}

img {
    vertical-align: middle;
    border-style: none;
}

/* Contact Us
---------------------*/
.contact-name {
    margin-bottom: 30px;
}

.contact-name h5 {
    font-size: 22px;
    color: #20247b;
    margin-bottom: 5px;
    font-weight: 600;
}

.contact-name p {
    font-size: 18px;
    margin: 0;
}

.social-share a {
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    color: #ffffff;
    text-align: center;
    margin-right: 10px;
}

.social-share .dribbble {
    box-shadow: 0 8px 30px -4px rgba(234, 76, 137, 0.5);
    background-color: #ea4c89;
}

.social-share .behance {
    box-shadow: 0 8px 30px -4px rgba(0, 103, 255, 0.5);
    background-color: #0067ff;
}

.social-share .linkedin {
    box-shadow: 0 8px 30px -4px rgba(1, 119, 172, 0.5);
    background-color: #0177ac;
}

.contact-form .form-control {
    border: none;
    border-bottom: 1px solid #20247b;
    background: transparent;
    border-radius: 0;
    padding-left: 0;
    box-shadow: none !important;
}

.contact-form .form-control:focus {
    border-bottom: 1px solid #fc5356;
}

.contact-form .form-control.invalid {
    border-bottom: 1px solid #ff0000;
}

.contact-form .send {
    margin-top: 20px;
}

@media (max-width: 767px) {
    .contact-form .send {
        margin-bottom: 20px;
    }
}

.section-title h2 {
    font-weight: 700;
    color: #20247b;
    font-size: 45px;
    margin: 0 0 15px;
    border-left: 5px solid #fc5356;
    padding-left: 15px;
}

.section-title {
    padding-bottom: 45px;
}

.contact-form .send {
    margin-top: 20px;
}

.px-btn {
    padding: 0 50px 0 20px;
    line-height: 60px;
    position: relative;
    display: inline-block;
    color: #20247b;
    background: none;
    border: none;
}

.px-btn:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    border-radius: 30px;
    background: transparent;
    border: 1px solid rgba(252, 83, 86, 0.6);
    border-right: 1px solid transparent;
    -moz-transition: ease all 0.35s;
    -o-transition: ease all 0.35s;
    -webkit-transition: ease all 0.35s;
    transition: ease all 0.35s;
    width: 60px;
    height: 60px;
}

.px-btn .arrow {
    width: 13px;
    height: 2px;
    background: currentColor;
    display: inline-block;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 25px;
}

.px-btn .arrow:after {
    width: 8px;
    height: 8px;
    border-right: 2px solid currentColor;
    border-top: 2px solid currentColor;
    content: "";
    position: absolute;
    top: -3px;
    right: 0;
    display: inline-block;
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>


<style scoped>
ul.timeline {
    list-style-type: none;
    position: relative;
}

ul.timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
}

ul.timeline>li {
    margin: 20px 0;
    padding-left: 20px;
}

ul.timeline>li>a {
    color: rgb(136, 0, 0);
}

ul.timeline>li:before {
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #007413;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}
</style>